import { Component, inject } from "@angular/core";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import { YesNoPipe } from "src/app/pipes/yes-no.pipe";
import {
  AnlageDetailDto,
  AnlagenClientProvider,
  DynamicLayoutDto,
  FieldDataType,
} from "src/app/web-api/web-api";

@Component({
    selector: "facility-masterdata",
    templateUrl: "./facility-masterdata.component.html",
    styleUrls: ["./facility-masterdata.component.scss"],
    standalone: false
})
export class FacilityMasterDataComponent extends CstResponsivePopupComponentBase {
  private _anlageClient = inject(AnlagenClientProvider);
  private _yesNoPipe = inject(YesNoPipe);


  public layout: DynamicLayoutDto = null;
  public masterData: AnlageDetailDto = null;

  onInitialised(): void {
    this._anlageClient.getStammdatenLayout().subscribe((result) => {
        this.layout = result;
    });
    this.masterData = this.data;
  }

  public getValueFromFieldID(fieldID: number):string{
      const result = this.masterData.stammdaten?.find(e=>e.fieldID === fieldID);
      if (result?.dataType === FieldDataType.Bool){
        return this._yesNoPipe.transform(result.value);
      }
      return result?.value;
  }

  // public isEyecatcher(fieldID: number): boolean{
  //   const result = this.masterData.stammdaten?.find(e=>e.fieldID === fieldID);
  //   return result?.xmlConfig?.includes('"IsEyeCatching" Value="True"');
  // }


}
